import styles from "./faq-block.module.less";
import Accordion from "../../elements/accordion/accordion";
import Heading from "../../elements/heading/heading";
import { TIndexableBlock } from "../../../types/general-block-types";

export type TFaqItem = {
  title: string;
  /** HTML string */
  body: string;
  open?: boolean;
};

export type TFaqBlockProps = {
  heading?: string;
  content?: string;
  items: Array<TFaqItem>;
} & TIndexableBlock;

const FaqBlock = ({ heading, content, items, index }: TFaqBlockProps) => {
  const accordionItems = items.map((item) => {
    return {
      id: item.title,
      heading: item.title,
      open: item.open ?? false,
      content: (
        <div
          className={[styles.accordionItemBody, "html-content"].join(" ")}
          dangerouslySetInnerHTML={{ __html: item.body }}
        />
      ),
    };
  });

  return (
    <section className={styles.section}>
      <article className={`max-width padded-sides ${styles.innerWrapper}`}>
        <div className={styles.contentWrapper}>
          <div className={styles.innerContentWrapper}>
            <Heading index={index} semanticType={"h2"} visualType={"h3"} className={"heading-max-width"}>
              {heading}
            </Heading>
            {content && (
              <div className={"body-base text-max-width"}>
                {content && (
                  <div
                    className={[styles.content, "html-content"].join(" ")}
                    dangerouslySetInnerHTML={{ __html: content }}
                  />
                )}
              </div>
            )}
            <div className={"text-max-width"}>
              <Accordion items={accordionItems} />
            </div>
          </div>
        </div>
      </article>
    </section>
  );
};

export default FaqBlock;
